import { Icon, Button } from '@sanlam-glacier/app-common/components';
import { useNavigate } from 'react-router-dom';
import { routes } from 'routes/route-paths';
import styles from 'modules/reports/overview/report-overview.module.scss';

interface NewReportButtonProps {
  alignEnd?: boolean;
}

const NewReportButton: React.FC<NewReportButtonProps> = () => {
  const navigate = useNavigate();

  const navigateToNewReport = () =>
    navigate(`${routes.reportsRoutes.new}/${routes.reportsRoutes.newReportRoutes.selectClients}/`);
  return (
    <Button
      className={styles.createReportBtn}
      onClick={navigateToNewReport}
      size={Button.SIZE.SMALL}
      startIcon={<Icon icon='content_add' />}
    >
      Create New Report
    </Button>
  );
};

export default NewReportButton;
